import Image from "next/image";

export default function UpcomingEventCardImage({ item }) {
  return (
    <figure className="flex-1">
      <Image
        src={process.env.NEXT_PUBLIC_SPACES_URL + item?.image}
        height={500}
        width={500}
        className="w-full h-full max-h-80 md:rounded-lg rounded-none object-cover"
        alt="event-1"
      />
    </figure>
  );
}
